import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ApprovePaymentPlanError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ApprovePaymentPlanError', ...args);
    }
}
export default ApprovePaymentPlanError;
